module.exports = __webpack_public_path__ + "static/media/paid.ce6017b0.png";